export const MAX_WIDTH = 768

// Client-side resize before upload. Resolves with the original file if it's
// already small enough, and never touches GIFs (canvas destroys animation).
export function resizeImage(file) {
  if (file.type === 'image/gif') return Promise.resolve(file)
  return new Promise(resolve => {
    const img = new Image()
    const url = URL.createObjectURL(file)
    img.onload = () => {
      URL.revokeObjectURL(url)
      if (img.width <= MAX_WIDTH) { resolve(file); return }
      const scale = MAX_WIDTH / img.width
      const canvas = document.createElement('canvas')
      canvas.width = MAX_WIDTH
      canvas.height = Math.round(img.height * scale)
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height)
      canvas.toBlob(blob => resolve(new File([blob], file.name, { type: file.type })), file.type, 0.88)
    }
    img.src = url
  })
}
